import { render, staticRenderFns } from "./PublicCoursePlay.vue?vue&type=template&id=5ba87d11&scoped=true&"
import script from "./PublicCoursePlay.vue?vue&type=script&lang=js&"
export * from "./PublicCoursePlay.vue?vue&type=script&lang=js&"
import style0 from "./PublicCoursePlay.vue?vue&type=style&index=0&id=5ba87d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba87d11",
  null
  
)

export default component.exports